import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const useGetTranslatedAttribute = () => {
    const { t } = useTranslation();

    const selectedLanguageCode = t('language_code');

    return useCallback((entity: any, attribute: string, languageCode?: string) => {
        const translations = entity?.translations ?? [];

        const attributeTranslation = translations.find((tr: any) => tr.attribute === attribute && tr.languageCode === (languageCode ?? selectedLanguageCode));

        if (attributeTranslation && attributeTranslation.value) {
            return attributeTranslation.value;
        } else {
            return entity[attribute];
        }
    }, [selectedLanguageCode]);
};

export default useGetTranslatedAttribute;